import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable } from 'react-native';

/** One row of a ⋯ menu. */
export const BiMenuRow = memo(
  ({
    icon: Icon,
    label,
    danger,
    disabled,
    onPress,
  }: {
    icon: LucideIcon;
    label: string;
    danger?: boolean;
    /** Shown but inert, e.g. 上移 on the first card. */
    disabled?: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const color = danger ? aiColors.destructive : aiColors.foreground;
    return (
      <Pressable
        accessibilityRole="menuitem"
        accessibilityLabel={label}
        accessibilityState={{ disabled: !!disabled }}
        disabled={disabled}
        onPress={onPress}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(10),
          paddingVertical: rpx(12),
          paddingHorizontal: rpx(4),
          opacity: disabled ? 0.4 : pressed ? 0.6 : 1,
        })}
      >
        <Icon size={16} color={color} />
        <Typography.Text size={rpx(14)} color={color}>
          {label}
        </Typography.Text>
      </Pressable>
    );
  },
);
